import React from "react";

const Header = ({ title, subtitle }) => {
    return (
        <div className="mb-8">
            <h2 className="text-3xl font-bold text-gray-100 mb-1">
                {title}
            </h2>
            <h5 className="text-lg text-emerald-400">
                {subtitle}
            </h5>
        </div>
    );
};

export default Header;
